import { useLang } from "@/context/LangContext";
import { COPY } from "@/components/landing/landingCopy";
import { Header } from "@/components/landing/landingPrimitives";
import PricingBody from "@/components/landing/PricingBody";

// Public Pricing marketing page. Composed as: shared PublicHeader
// (with Pricing set active) + PricingBody. Bilingual copy lives
// inside PricingBody. Only route wired in this pass is /pricing.
export default function Pricing() {
  const { lang, setLang } = useLang();
  const c = COPY[lang] || COPY.en;
  return (
    <div className="min-h-screen bg-white" data-testid="pricing-root">
      <Header c={c} lang={lang} setLang={setLang} activePage="pricing" />
      <PricingBody lang={lang} />
    </div>
  );
}
